<form [formGroup]="form" class="form-container" (submit)="save()">
  <h3>Favoritos - Banners</h3>

  <p-panel header="Período">
    <div class="form-field">
      <label>Data de início (obrigatório)</label>
      <p-calendar
        [showTime]="true"
        formControlName="beginDate"
        [ngClass]="{ error: isBeginDateInvalid() }"
        [minDate]="today"
        [showButtonBar]="true"
      ></p-calendar>
      <p class="error-message" *ngIf="isBeginDateInvalid()">
        Data é um campo obrigatório.
      </p>
    </div>

    <div class="form-field">
      <label>Data de término</label>
      <p-calendar
        [showTime]="true"
        formControlName="endDate"
        [ngClass]="{ error: isEndDateInvalid() }"
        [minDate]="today"
        [showButtonBar]="true"
      ></p-calendar>
      <p class="error-message" *ngIf="isEndDateInvalid()">Data inválida.</p>
    </div>
  </p-panel>

  <p-panel header="Conteúdo">
    <div class="form-field">
      <label>Title (obrigatório)</label>
      <input
        type="text"
        pInputText
        formControlName="title"
        [ngClass]="{ error: isTitleInvalid() }"
      />
      <p class="error-message" *ngIf="isTitleInvalid()">
        Title é um campo obrigatório.
      </p>
    </div>
    <div class="form-field">
      <label> Banner (obrigatório) </label>
      <p-fileUpload
        mode="basic"
        chooseLabel="upload"
        name="demo[]"
        [auto]="true"
        accept="image/webp"
        (onSelect)="handleFileSelect($event, 'image', 0, 0, 0, desktopImage)"
        [showUploadButton]="false"
        [showCancelButton]="false"
        #desktopImage
        styleClass="p-button-raised p-button-secondary"
      ></p-fileUpload>
    </div>
    <div class="form-container__img">
      <img *ngIf="bannerUrl" [src]="bannerUrl" />
    </div>
    <br />
    <div class="form-field">
      <p-button
        styleClass="p-button-outlined cancel-button"
        label="Cancelar"
        (onClick)="goToMenu()"
      ></p-button>
    </div>
    <div class="form-field">
      <p-button
        type="submit"
        styleClass="p-button"
        label="Salvar"
        [disabled]="!form.valid"
      ></p-button>
    </div>
  </p-panel>
</form>
